var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('UserTopBar',{attrs:{"user-name":_vm.infoCont.name,"role":_vm.infoCont.rol,"email":_vm.infoCont.email,"user-image":_vm.infoCont.avatar,"usepackage":_vm.infoCont.account_type_name,"phone":_vm.infoCont.phone,"company":_vm.infoCont.company}})],1),_c('Setari')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }